// extracted by mini-css-extract-plugin
export default {"container":"Board_container__BXSSD","empty":"Board_empty__zD9po","player1":"Board_player1__a5pQK","player2":"Board_player2__AxyeR"};